import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import partnerOrchestratorService from 'services/partnerOrchestratorService';
import { PartnerLockType } from 'types/PartnerLockTypes';

export const useFetchPartnerLockStatus = (partnerUid: string) => {
  return useQuery<PartnerLockType[], AxiosError>({
    queryKey: ['useFetchPartnerLockStatus', partnerUid],
    queryFn: () => partnerOrchestratorService.getPartnerLockStatus(partnerUid),
    gcTime: 0,
  });
};
